import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const iqRoutes: CustomRouteRecordRaw = {
  path: 'iq',
  name: 'iq',
  component: EmptyLayout,
  redirect: { name: 'workbench' },
  meta: {
    title: 'IQ测评',
    iconfont: 'icon-user-heart-line',
    requiredPermission: 'iq',
  },
  children: [
    {
      path: 'iq-test-list',
      name: 'iqTestList',
      component: () => import('@/views/iq/iq-test-list.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'iq.test.list',
      },
    },
    {
      path: 'iq-test-report',
      name: 'iqTestReport',
      component: () => import('@/views/iq/iq-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'iq.test.report',
      },
    },
  ],
}
